import React from 'react'
import "../styles/components/Banner.css"

function Banner() {
  return (
    <header class="home-banner" id='home-banner'>
        <img class="logo-banner-home" src="./img/accueil/logo-banner.png" alt="Bannière"/>
    </header>
  )
}

export default Banner